export default __webpack_public_path__ + "static/media/aero-concentrator.5f168734.jpg";